<template>
  <div class="tab-container">
    <div class="tab-section">
      <VForm :callback="() => {}">
        <template #form-body>
          <h4>{{ $t("game.homeView.accountSettings.information.title") }}</h4>
          <div class="input-inline">
            <VField name="profil-firstname" rules="required|textOnly" v-model="candidate.personal_information.first_name" :label="$t('app.form.register.firstName')" :disabled="true" />
            <VField name="profil-lastname" rules="required|textOnly" v-model="candidate.personal_information.last_name" :label="$t('app.form.register.lastName')" :disabled="true" />
          </div>
          <div class="input-inline">
            <VField type="email" name="profil-mail" rules="required|email" v-model="candidate.personal_information.email" :label="$t('app.form.email')" :disabled="true" />
          </div>
        </template>
      </VForm>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate";

const { candidate } = useCandidateStore();

const state = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  error: "",
});
</script>
